"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProgressBar = function ProgressBar(_ref) {
  var className = _ref.className,
      percentage = _ref.percentage,
      progressBarClassName = _ref.progressBarClassName;
  var wrapperClasses = (0, _classnames.default)(className, {
    'pds-progress-bar-wrapper': true
  });
  var progressBarClasses = (0, _classnames.default)(progressBarClassName, {
    'pds-progress-bar': true
  });
  return _react.default.createElement("div", {
    className: wrapperClasses
  }, _react.default.createElement("div", {
    className: progressBarClasses,
    style: {
      width: "".concat(percentage, "%")
    }
  }));
};

ProgressBar.propTypes = {
  /**
   * Applies additional CSS classes to the outer wrapper element of the
   * ProgressBar (unfilled part of the container).
   */
  className: _propTypes.string,

  /**
   * A number used to represent the filled portion of the ProgressBar component.
   */
  percentage: _propTypes.number.isRequired,

  /**
   * Applies additional CSS classes to the inner element of the ProgressBar
   * (filled part of the container).
   */
  progressBarClassName: _propTypes.string
};
ProgressBar.defaultProps = {
  className: null,
  progressBarClassName: null
};
var _default = ProgressBar;
exports.default = _default;
